import React, { useContext, useMemo } from "react";
import ViewIcon from "@material-ui/icons/InputOutlined";
import EditIcon from "@material-ui/icons/EditOutlined";
import { DividendList } from "../../../data/reports/dividends/types";
import { DividendData } from "../../../data/reports/dividends/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { MaterialTableProps } from "material-table";
import { useViewDividends } from "./DisplayDividends";
import { useHistory } from "react-router-dom";
import { getDividendsEditLocation } from "./Locations";
import { useAuth } from "../../../data/auth/hooks";

export function useDividendsActions() {
  const { getString } = useContext(LocalizationContext);
  const onShowDividends = useViewDividends();

  const [auth] = useAuth();

  return useMemo(() => {
    const result: MaterialTableProps<DividendList>["actions"] = [
      {
        icon: () => <ViewIcon />,
        tooltip: getString("newsShow"),
        onClick: (event, rowData) => onShowDividends(rowData as DividendList),
      },

    ];
    return result;
  }, [onShowDividends,  getString]);
}


